const TELEGRAM_APP_URL = "https://t.me/evil_coin_bot/game";
const DOMAIN = "https://evilcoin-dev.getboond.com/";

// Determine if we're in a local/development environment using webpack's environment variable
const isLocalBuild = process.env.NODE_ENV === "development";

// Get the base URL without any pathname parts for API calls
const getBaseUrl = () => {
  if (typeof window === "undefined") return DOMAIN;

  // Return just the origin without any pathname parts to avoid conflicts with routing
  return window.location.origin;
};

// Set SERVER_API_URL based on environment
const SERVER_API_URL = isLocalBuild ? DOMAIN : getBaseUrl();
const TON_CONNECT_MANIFEST_URL = `${SERVER_API_URL}/tonconnect-manifest.json`;

export { SERVER_API_URL, TON_CONNECT_MANIFEST_URL, TELEGRAM_APP_URL };
